import script from "./PasswordFields.vue?vue&type=script&lang=ts&setup=true"
export * from "./PasswordFields.vue?vue&type=script&lang=ts&setup=true"

import "./PasswordFields.vue?vue&type=style&index=0&id=c3d92198&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3d92198"]])

export default __exports__